import React from 'react';
import HomePageFooterSvgs from './HomePageFooterSvgs';

export default function HomePageFooter() {
  return (
    <footer className="footer footer-default" role="contentinfo">
      <HomePageFooterSvgs />
      <div className="container">
        <nav className="row">
          <div className="col-xs-12 col-md-2">
            <div className="footer-logo">
              <a href="http://spotifyforbrands.com/us">Spotify</a>
            </div>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-2">
            <h3 className="nav-title">Company</h3>
            <ul className="nav">
              <li>
                <a className="nav-link" href="https://www.spotify.com/us/about-us/contact/">
                  About
                </a>
              </li>
              <li>
                <a className="nav-link" href="https://www.spotify.com/us/jobs/">
                  Jobs
                </a>
              </li>
              <li>
                <a className="nav-link" href="https://press.spotify.com/us/">
                  Press
                </a>
              </li>
              <li>
                <a className="nav-link" href="https://news.spotify.com/us/">
                  News
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-2">
            <h3 className="nav-title">Community</h3>
            <ul className="nav">
              <li>
                <a className="nav-link" href="https://www.spotifyartists.com/">
                  Artists
                </a>
              </li>
              <li>
                <a className="nav-link" href="https://developer.spotify.com/">
                  Developers
                </a>
              </li>
              <li>
                <a className="nav-link" href="https://www.spotify.com/us/brands/">
                  Brands
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xs-6 col-sm-4 col-md-2">
            <h3 className="nav-title">Useful Links</h3>
            <ul className="nav">
              <li>
                <a
                  className="nav-link"
                  href="https://support.spotify.com/?utm_source=www.spotify.com&utm_medium=www_footer&_ga=2.179794404.1176359094.1504624428-334658961.1490890546"
                >
                  Help
                </a>
              </li>
              <li>
                <a className="nav-link" href="https://www.spotify.com/us/purchase/ecards/">
                  Gift
                </a>
              </li>
              <li>
                <a className="nav-link" href="https://www.spotify.com/us/redirect/webplayerlink/?utm_medium=www_footer">
                  Web Player
                </a>
              </li>
            </ul>
          </div>
          <div className="col-xs-12 col-md-4 col-social">
            <ul className="nav">
              <li>
                <a href="http://instagram.com/spotify">
                  <svg className="social-icon">
                    <use xlinkHref="#instagram-icon" />
                  </svg>
                  <span className="social-text">Instagram</span>
                </a>
              </li>
              <li>
                <a href="https://twitter.com/spotify">
                  <svg className="social-icon">
                    <use xlinkHref="#twitter-icon" />
                  </svg>
                  <span className="social-text">Twitter</span>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/Spotify">
                  <svg className="social-icon">
                    <use xlinkHref="#facebook-icon" />
                  </svg>
                  <span className="social-text">Facebook</span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <nav className="row row-small">
          <div className="col-xs-7 col-md-4 col-md-offset-2">
            <ul className="nav nav-small">
              <li>
                <a href="https://www.spotify.com/legal/">Legal</a>
              </li>
              <li>
                <a href="https://www.spotify.com/legal/privacy-policy/#cookies">Cookies</a>
              </li>
            </ul>
          </div>
          <div className="col-xs-5 col-md-6 text-right">
            <a className="market" href="https://www.spotify.com/select-your-country">
              <div className="media">
                <div className="media-body media-middle">United States</div>
                <div className="media-right media-middle">
                  <span className="media-object flag-icon flag-icon-us" />
                </div>
              </div>
            </a>
            <small className="copyright">&copy; 2017 Spotify AB</small>
          </div>
        </nav>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/components/MarketingPageFooter/index.js